import React from 'react'
import { Grid, Typography, Paper, Button } from '@material-ui/core';
export class PageNotFound extends React.Component{
    constructor(props){
        super(props);
    }

    render(){
        return <Grid container style={{marginTop:'70px',padding:'20px'}} justify='center'>
                    <Grid xs={12} lg={10} sm={10} md={10}  item >
                        <Paper>
                            <Grid container justify='space-around'>

                                <Grid xs={12} lg={6} sm={12} md={6} item >
                                    <img src='/404.svg' style={{width:'100%',height:'100%'}}/>
                                </Grid>

                                <Grid xs={12} lg={6} sm={12} md={6} item >
                                        <div style={{
                                            display:'flex',
                                            justifyContent:'center',
                                            alignItems:'center',
                                            padding:'20px',
                                            flexDirection:'column',
                                            width:'100%',
                                            height:'100%'
                                        }}>
                                            <div style={{
                                            display: 'flex',
                                            justifyContent: 'space-around',
                                            width: '180px',
                                            alignItems: 'center'
                                            }}>
                                                <div>
                                                    <img src='/logo.png' style={{width: '50px',height: '50px'}}/>
                                                </div>
                                                <div><Typography variant='h4'>Actumjs</Typography></div>
                                            </div>
                                            <Typography variant='h4' align='center'>
                                                Sorry,page not found
                                            </Typography>
                                            <Button component={'a'} href='/' variant='text' color='primary' >Back to home</Button>
                                        </div>
                                </Grid>

                            </Grid>
                        </Paper>
                    </Grid>
                </Grid>
    }
}
